<template>
	<div>
		<Popup
			v-model:show="showModifyScore"
			position="bottom"
			closeable
			:close-on-click-overlay="false"
			:style="{ height: '45%' }">
			<div style="font-size: var(--base-px-18);font-weight: bold;text-align: center;padding-top: var(--base-px-15);">
				修改评分
			</div>
			<Divider/>
			<div style="display: flex;" class="modify_page">
				给客户
				<div style="margin-left: var(--base-px-5);margin-top: -5px;" class="option_row">
					<select>
						<option>添加</option>
						<option>减少</option>
					</select>
				</div>
				<input type="number" v-model="scoreNum" class="input_style">分
			</div>
			<div style="display: flex;justify-content:center;margin-top: var(--base-px-15);">
				<textarea class="textarea" placeholder="请输入修改评分备注"></textarea>
			</div>
		</Popup>
	</div>
</template>
<script>
import {Popup, Divider} from 'vant'

export default {
	components: {
		Popup, Divider
	},
	data() {
		return {
			showModifyScore: false,
			scoreNum: ''
		}
	},
	methods: {
		show() {
			this.showModifyScore = true
		}
	}
}
</script>
<style scoped lang="less">
.textarea {
	border: var(--base-px-1) solid #E8E8E8;
	height: var(--base-px-200);
	width: calc(100% - var(--base-px-130));
	padding: var(--base-px-20) var(--base-px-30) var(--base-px-20) var(--base-px-30);
	font-size: var(--base-px-27);
	resize: none;
}

.modify_page {
	font-size: var(--base-px-28);
	padding: 0 var(--base-px-35) 0 var(--base-px-35);
}

.option_row {
	width: var(--base-px-150);
	height: var(--base-px-50);
	border: var(--base-px-1) solid #cccccc;
	position: relative;
}

.option_row select {
	position: absolute;
	top: 0;
	/*清除select的边框样式*/
	border: none;
	/*清除select聚焦时候的边框颜色*/
	outline: none;
	/*将select的宽高等于div的宽高*/
	width: 100%;
	height: var(--base-px-50);
}

.option_row option {
	height: var(--base-px-10);
}

.input_style {
	width: var(--base-px-100);
	height: var(--base-px-45);
	border: var(--base-px-1) solid #cccccc;
	margin-top: var(--base-px--9);
	margin-left: var(--base-px-10);
	margin-right: var(--base-px-10);
}
</style>
